import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Modals from '../../../../shared/types/enums/modals';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import { store } from '../../../../shared/store/store';

const getModalStyle = () => {
  const { modal } = store.getState();
  switch (modal.current) {
    case Modals.ACTIVATE_GENERIC:
    case Modals.ACTIVATE_ZAPPER:
      return {
        top: `${372 * Screen.widthRatio}px`,
      };
    case Modals.ANONYMOUS_GENERIC:
    case Modals.ANONYMOUS_ZAPPER:
      return {
        top: `${515 * Screen.widthRatio}px`,
      };
    case Modals.PARENTAL_PIN_GENERIC:
      return {
        'line-height': `${60 * Screen.widthRatio}px`,
        top: `${292 * Screen.widthRatio}px`,
        width: `${1454 * Screen.widthRatio}px`,
      };
    case Modals.PARENTAL_PIN_ZAPPER:
      return {
        'line-height': `${60 * Screen.widthRatio}px`,
        top: `${412 * Screen.widthRatio}px`,
        width: `${1454 * Screen.widthRatio}px`,
      };
    case Modals.GENERIC_ERROR:
    case Modals.PLAYER_ERROR:
      return {
        position: 'unset',
        margin: `${10 * Screen.widthRatio}px auto`,
        top: `${280 * Screen.widthRatio}px`,
      };
    case Modals.RECORDING_REQUEST:
      return {
        'font-size': `${45 * Screen.widthRatio}px`,
        top: `${562 * Screen.widthRatio}px`,
      };
  }
  return '';
};

const ModalSubtitle = styled.span<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['regular']};
  font-size: ${36 * Screen.widthRatio}px;
  height: fit-content;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  text-align: center;
  max-width: ${1200 * Screen.widthRatio}px;
  width: fit-content;
  ${() => {
    return getModalStyle();
  }}
`;

export default ModalSubtitle;
